import React from 'react';
import { render } from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';

import Login from './App';

render(<Login />, document.getElementById('Login'));
